import { render, staticRenderFns } from "./ViewNotifications.vue?vue&type=template&id=9b70483a&scoped=true"
import script from "./ViewNotifications.vue?vue&type=script&lang=js"
export * from "./ViewNotifications.vue?vue&type=script&lang=js"
import style0 from "./ViewNotifications.vue?vue&type=style&index=0&id=9b70483a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b70483a",
  null
  
)

export default component.exports